import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { BrandService } from '../proxy/general/controllers/brand.service';
import { ModelService } from '../proxy/general/controllers/model.service';

FieldBuilder.setNamespace('General');

export const CLAW_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('size', 'Entity.Claw.Size')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('brandId', 'Entity.Brand', BrandService)
    .displayFromNested('brand.name')
    .sortBy('brand.name')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('modelId', 'Entity.Model', ModelService)
    .displayFromNested('model.name')
    .sortBy('model.name')
    .required()
    .build(),
];

export const CLAW_CONFIG = {
  entityName: 'Claw',
  localizationKey: 'General::Entity.Claw',
  fields: CLAW_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Claws',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
